<script lang="ts">
  let { label = "Loading…" }: { label?: string } = $props();
</script>

<div class="flex items-center gap-2.5 px-1 py-7 text-muted text-sm" role="status">
  <span
    class="h-4 w-4 rounded-full border-2 border-border-strong border-t-brand animate-spin"
    aria-hidden="true"
  ></span>
  <span>{label}</span>
</div>
